import React from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import componentStyles from './Spinner.module.scss'
import styles from '@bt-react/styles'
import classnames from 'classnames'

class Spinner extends React.Component {

  render () {

    const { header = '', body = '', invert = false, isComplete = false } = this.props

    const spinnerClasses = classnames(
      componentStyles[`spinner`], {
        [componentStyles[`spinner--invert`]]: invert
      }
    )

    const messageClasses = classnames(
      componentStyles[`spinner__message`], {
        [styles[`text-primary-bt`]]: !invert
      }
    )

    return <div className={spinnerClasses}>
      {!isComplete && <Icon name={IconType.iconName.spinner} className={componentStyles[`spinner__icon`]} colour={invert ? IconType.colour.white : IconType.colour.secondary} />}
      {isComplete && <Icon name={IconType.iconName.tick} className={componentStyles[`spinner__icon`]} colour={invert ? IconType.colour.white : IconType.colour.brightTALK} />}
      {header !== '' && <div className={messageClasses} data-bdd={`spinner-header`} >{header}</div>}
      {body !== '' && <div className={componentStyles[`spinner__message-body`]} data-bdd={`spiner-body`} >{body}</div>}
    </div>

  }

}

export default Spinner
